import React from 'react';

class NotFound extends React.Component {
  render() {
    return <div />;
  }
}

export default NotFound;
